import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { API_URL, PARSE_APPLICATION_ID, PARSE_REST_API_KEY } from "../api";
import Parse from "parse";

export const getAllClientGifts = createAsyncThunk(
  "giftsProducts/getAllProducts",
  async (payload, { getState, rejectWithValue }) => {
    try {
      const url = API_URL + "/classes/Prize";
      const user = getState().user.userMe;
      //   const value = localStorage.getItem("user");
      //   const user = JSON.parse(value);

      const options = {
        method: "GET",
        headers: {
          "X-Parse-Application-Id": PARSE_APPLICATION_ID,
          "X-Parse-REST-API-Key": PARSE_REST_API_KEY,
          "X-Parse-Session-Token": user.sessionToken,
          "Content-Type": "application/json",
        },
      };

      const res = await fetch(url, options);
      if (res.error) {
        rejectWithValue(res.error);
      }
      const data = res.json();
      return data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const getAllClientProducts = createAsyncThunk(
  "giftsProducts/getAllClientProducts",
  async (payload, { getState, rejectWithValue }) => {
    try {
      const url = API_URL + "/classes/Product";
      const user = getState().user.userMe;
      const options = {
        method: "GET",
        headers: {
          "X-Parse-Application-Id": PARSE_APPLICATION_ID,
          "X-Parse-REST-API-Key": PARSE_REST_API_KEY,
          "X-Parse-Session-Token": user.sessionToken,
          "Content-Type": "application/json",
        },
      };

      const res = await fetch(url, options);
      if (res.error) {
        rejectWithValue(res.error);
      }
      const data = res.json();
      return data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const purchasePrize = createAsyncThunk(
  "giftsProducts/purchasePrize",
  async (payload, { getState, rejectWithValue }) => {
    try {
      const url = API_URL + "/functions/purchase-prize";
      const user = getState().user.userMe;
      const options = {
        method: "POST",
        headers: {
          "X-Parse-Application-Id": PARSE_APPLICATION_ID,
          "X-Parse-REST-API-Key": PARSE_REST_API_KEY,
          "X-Parse-Session-Token": user.sessionToken,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          prize: payload.prize,
          //objectId i email
          user: payload.user,
          shippingInfo: [payload.shippingInfo],
        }),
      };

      const res = await fetch(url, options);
      if (res.error) {
        rejectWithValue(res.error);
      }
      const data = res.json();
      return data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const getAllPrizeHistory = createAsyncThunk(
  "giftsProducts/getAllPrizeHistory",
  async (payload, { getState, rejectWithValue }) => {
    try {
      const url = API_URL + "/classes/PrizeHistory";
      const user = payload.user;
      const options = {
        method: "GET",
        headers: {
          "X-Parse-Application-Id": PARSE_APPLICATION_ID,
          "X-Parse-REST-API-Key": PARSE_REST_API_KEY,
          "X-Parse-Session-Token": user.sessionToken,
          "Content-Type": "application/json",
        },
      };

      const res = await fetch(url, options);
      if (res.error) {
        rejectWithValue(res.error);
      }
      const data = res.json();
      return data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);
export const getAllPrizeHistoryQuery = createAsyncThunk(
  "giftsProducts/getAllPrizeHistoryQuery",
  async (payload, { getState, rejectWithValue }) => {
    try {
      const query = new Parse.Query("PrizeHistory");
      const giftCount = await query.count();
      query.limit(payload.pageSize);
      query.skip(payload.page);
      const data = await query.find();

      return { data, count: giftCount };
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);
export const getAllPrizeHistoryForExcel = createAsyncThunk(
  "giftsProducts/getAllPrizeHistoryForExcel",
  async (payload, { getState, rejectWithValue }) => {
    try {
      const query = new Parse.Query("PrizeHistory");
      query.limit(5000);
      const data = await query.find();

      return data
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);
export const getAllUserPrizeHistory = createAsyncThunk(
  "giftsProducts/getAllUserPrizeHistory",
  async (payload, { getState, rejectWithValue }) => {
    try {
      const url = API_URL + "/functions/get-user-prizes";
      const user = getState().user.userMe;
      const userMeId = getState().user.userMeId;
      const options = {
        method: "POST",
        headers: {
          "X-Parse-Application-Id": PARSE_APPLICATION_ID,
          "X-Parse-REST-API-Key": PARSE_REST_API_KEY,
          "X-Parse-Session-Token": user.sessionToken,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          userId: userMeId,
        }),
      };

      const res = await fetch(url, options);
      if (res.error) {
        rejectWithValue(res.error);
      }
      const data = res.json();
      return data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

const initialState = {
  getAllClientGiftsLoading: "IDLE",
  getAllClientGiftsError: null,
  allGifts: null,
  getAllClientProductsLoading: "IDLE",
  getAllClientProductsError: null,
  allProducts: null,
  purchasePrizeLoading: "IDLE",
  purchasePrizeError: null,
  getAllPrizeHistoryLoading: "IDLE",
  getAllPrizeHistoryError: null,
  allPrizeHistory: null,
  allPrizeCount: 0,
  getAllUserPrizesLoading: "IDLE",
  getAllUserPrizesError: null,
  allUserPrizes: null,
  getAllPrizeHistoryForExcelLoading: "IDLE",
  getAllPrizeHistoryForExcelError: null,
  allUserPrizesForExcel: null
};

export const giftsProductsSlice = createSlice({
  name: "giftsProducts",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAllClientGifts.pending, (state, action) => {
      state.getAllClientGiftsLoading = "PENDING";
      state.getAllClientGiftsError = null;
    });
    builder.addCase(getAllClientGifts.fulfilled, (state, action) => {
      state.getAllClientGiftsLoading = "SUCCESS";
      state.getAllClientGiftsError = null;
      state.allGifts = action.payload.results;
    });
    builder.addCase(getAllClientGifts.rejected, (state, action) => {
      state.getAllClientGiftsLoading = "FAILED";
      const err = {
        code: action.payload?.code,
        message: action.payload?.message,
      };
      state.getAllClientGiftsError = err;
    });

    builder.addCase(getAllClientProducts.pending, (state, action) => {
      state.getAllClientProductsLoading = "PENDING";
      state.getAllClientProductsError = null;
    });
    builder.addCase(getAllClientProducts.fulfilled, (state, action) => {
      state.getAllClientProductsLoading = "SUCCESS";
      state.getAllClientProductsError = null;
      state.allProducts = action.payload.results;
    });
    builder.addCase(getAllClientProducts.rejected, (state, action) => {
      state.getAllClientProductsLoading = "FAILED";
      const err = {
        code: action.payload.code,
        message: action.payload.message,
      };
      state.getAllClientProductsError = err;
    });

    builder.addCase(purchasePrize.pending, (state, action) => {
      state.purchasePrizeLoading = "PENDING";
      state.purchasePrizeError = null;
    });
    builder.addCase(purchasePrize.fulfilled, (state, action) => {
      state.purchasePrizeLoading = "SUCCESS";
      state.purchasePrizeError = null;
    });
    builder.addCase(purchasePrize.rejected, (state, action) => {
      state.purchasePrizeLoading = "FAILED";
      const err = {
        code: action.payload.code,
        message: action.payload.message,
      };
      state.purchasePrizeError = err;
    });

    builder.addCase(getAllPrizeHistory.pending, (state, action) => {
      state.getAllPrizeHistoryLoading = "PENDING";
      state.getAllPrizeHistoryError = null;
    });
    builder.addCase(getAllPrizeHistory.fulfilled, (state, action) => {
      state.getAllPrizeHistoryLoading = "SUCCESS";
      state.getAllPrizeHistoryError = null;
      state.allPrizeHistory = action.payload.results;
    });
    builder.addCase(getAllPrizeHistory.rejected, (state, action) => {
      state.getAllPrizeHistoryLoading = "FAILED";
      const err = {
        code: action.payload.code,
        message: action.payload.message,
      };
      state.getAllPrizeHistoryError = err;
    });

    builder.addCase(getAllPrizeHistoryQuery.pending, (state, action) => {
      state.getAllPrizeHistoryLoading = "PENDING";
      state.getAllPrizeHistoryError = null;
    });
    builder.addCase(getAllPrizeHistoryQuery.fulfilled, (state, action) => {
      state.getAllPrizeHistoryLoading = "SUCCESS";
      state.getAllPrizeHistoryError = null;
      state.allPrizeHistory = action.payload.data;
      state.allPrizeCount = action.payload.count;
    });
    builder.addCase(getAllPrizeHistoryQuery.rejected, (state, action) => {
      state.getAllPrizeHistoryLoading = "FAILED";
      const err = {
        code: action.payload.code,
        message: action.payload.message,
      };
      state.getAllPrizeHistoryError = err;
    });

    builder.addCase(getAllPrizeHistoryForExcel.pending, (state, action) => {
      state.getAllPrizeHistoryForExcelLoading = "PENDING";
      state.getAllPrizeHistoryForExcelError = null;
    });
    builder.addCase(getAllPrizeHistoryForExcel.fulfilled, (state, action) => {
      state.getAllPrizeHistoryForExcelLoading = "SUCCESS";
      state.getAllPrizeHistoryForExcelError = null;
      state.allUserPrizesForExcel = action.payload;
    });
    builder.addCase(getAllPrizeHistoryForExcel.rejected, (state, action) => {
      state.getAllPrizeHistoryForExcelLoading = "FAILED";
      const err = {
        code: action.payload?.code,
        message: action.payload?.message,
      };
      state.getAllPrizeHistoryForExcelError = err;
    });
  },
});

// this is for dispatch
export const {} = giftsProductsSlice.actions;

// this is for configureStore
export default giftsProductsSlice.reducer;
